import styled, { keyframes } from 'styled-components';

export const Auth0AnimationWrapper = styled.div`
  position: relative;
  max-width: 100%;
  /* min-height: 811px; */
  padding: 80px 0;
  margin: 0 auto;
  border-radius: 3px;
  background-color: #f8f8f8;
  box-shadow: 0 20px 70px 0 rgba(0, 0, 0, 0.2);
  z-index: 30;
  /* animation: slideIntro 1s ease-out 0.5s; */
`;

export const OuterContainer = styled.div`
  position: relative;
`;

export const Title = styled.h2`
  margin: 0 0 12px;
  font-size: 24px;
  font-weight: 300;
  line-height: 40px;
  text-align: center;
  color: #333333;
  @media (min-width: 992px) {
    font-size: 36px;
    line-height: 60px;
  }
`;

export const Paragraph = styled.p`
  margin: 0 auto;
  max-width: 800px;
  font-size: 18px;
  letter-spacing: 0;
  text-align: center;
  line-height: 32px;
  color: #5c666f;
  @media (min-width: 992px) {
    font-size: 20px;
  }
`;

export const WrapperButtons = styled.div`
  padding: 2em 0;
  width: 100%;
`;

export const fadeIntro = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;

export const FadeLayer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #f8f8f8;
  animation: ${fadeIntro} 1.2s ease-in forwards;
  opacity: 1;
`;



// WEBPACK FOOTER //
// ./src/components/Auth0Animation/styled.js